module.exports = __webpack_public_path__ + "img/tree-fold.8f0dbc05.svg";